import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Switch,
} from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import theme from 'assets/styles/theme';
import {
  //COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  LS_DEFAULT_WAREHOUSE_KEY,
  LOADING_ICON_SIZE1,
} from 'constants/config';
import { SetDefaultWarehouseDialog } from 'components/common';
import Loading from 'components/common/Loading';
import { Label } from 'components/common/styles';
import { fetchWarehouseLocationList } from 'services/warehouse';
import { adjustPack } from 'services/prepack';
import { getWarehouseFromCache } from 'utils';


const AdjustmentWrapper = styled.div`
  margin: 20px 10px;

  & .act-btn {
    width: 100%;
  }

  & .bottom-btn-ctn {
    margin-top: 20px;
  }

  & .err-msg-ctn {
    color: ${theme['@danger-color']};
  }

  & .form-bottom-border {
    border-bottom: 1px solid #D9D9D9;
  }

  & .form-item-ctn {
    padding: 5px 0;
  }

  & .input-prd-qty-ctn .ant-input-number-group-wrapper {
    width: 100%;
  }

  & .label-ctn {
    margin-bottom: 5px;
  }

  & .input-ctn .ant-input-clear-icon {
    font-size: 24px;
  }
`;

const locationDict: StringKAnyVPair = {};

const UnpackAdjst = () => {
  const FORM_ELEMENT_SIZE = 'large';
  const { useState } = React;
  const [currentFromWarehouse, setCurrentFromWarehouse] = useState<StringKAnyVPair>({});
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] = useState(false);
  const [fromLocation, setFromLocation] = useState<number>();
  //const [fromWarehouseList, setFromWarehouseList] = useState<StringKAnyVPair[]>();
  const [inited, setInited] = useState(false);
  const [isAdjusting, setIsAdjusting] = useState(false);
  const [isLoadingWHLocation, setIsLoadingWHLocation] = useState(false);
  const [itemQty, setItemQty] = useState(1);
  const [skuInputVersion, setSkuInputVersion] = useState(0);
  const [toLocation, setToLocation] = useState<number>();
  const [toLocationOptions, setToLocationOptions] = useState<any[]>([]);
  const [unpackAtSrcLocation, setUnpackAtSrcLocation] = useState(true);
  const [PrepackSKU, setPrepackSKU] = useState<string>('')

  const skuSearchRef = React.useRef<any>(null);

  const history = useHistory();

  const adjust = async () => {
    if (isAdjusting) return;

      const param = [{
        WarehouseNum: currentFromWarehouse.warehouseNum,
        PrepackSKU: PrepackSKU,
        FromLocationNum: fromLocation,
        ToLocationNum: toLocation,
        PackQty: itemQty,
      }];

      //console.log(param, skuItem);
      setIsAdjusting(true);

      try {
        const res = await adjustPack(param);

        if (res && res.isSuccess) {
          if(res.data && res.data.length > 0){
            if(res.data[0].Success){
              Modal.confirm({
                cancelText: 'No',
                okText: 'Yes',
                centered: true,
                title: 'Adjusted successfully! Do you want to adjust another?',
                onCancel() {
                  onClose();
                },
                onOk() {
                  setSkuInputVersion(skuInputVersion + 1);
                  clearForm();
                  setTimeout(() => {
                    focusPrepackSkuSearchBox();
                  }, 0);
                },
              });
            } else {
              if (res.data[0].Message) {
                Modal.error({
                  centered: true,
                  title: `Error: ${res.data[0].Message}`,
                });
              }
            }
          }
        } else {
          Modal.error({
            centered: true,
            title: `error: ${res.message}`,
          });
        }
      } catch(e) {
        //console.log('e:', e);
        Modal.error({
          centered: true,
          title: `Error: ${e}`,
        });
      } finally {
        setIsAdjusting(false);
      }
  };

  const clearForm = () => {
    //setSku('');
    setItemQty(1);
    setFromLocation(undefined);
    setToLocation(undefined);
  };

  const focusPrepackSkuSearchBox = () => {
    if (skuSearchRef.current) {
      skuSearchRef.current.focus();
    }
  };

  // const isAdjustQtyValid = () => {
  //   const skuItem = skuItemList.find(e => e.locationNum === fromLocation);

  //   return skuItem && itemQty <= skuItem.quantity;
  // };

  const isDataInitialized = () => {
    return toLocationOptions.length > 0;
  };

  const isUnpackAvailable = () => {
    return fromLocation && toLocation && PrepackSKU;
  };

  // eslint-disable-next-line
  const loadInitialData = async (wh = currentFromWarehouse) => {
    setIsLoadingWHLocation(true);

    try {
      if (!wh.warehouseId) {
        setIsLoadingWHLocation(false);
        return;
      }

      const locations = locationDict[wh.warehouseNum] ? locationDict[wh.warehouseNum] : await fetchWarehouseLocationList(wh.warehouseId, true);

      //console.log('wh', wh, locations);
      if (Array.isArray(locations)) {
        const opts = locations.map(e => {
          return {
            label: e.locationCode,
            value: e.locationNum,
          };
        });

        if (!locationDict[wh.warehouseNum]) {
          locationDict[wh.warehouseNum] = locations;
        }

        setToLocationOptions(opts);
      }
    } finally {
      setIsLoadingWHLocation(false);
      setTimeout(focusPrepackSkuSearchBox, 500);
    }
  };

  // const maxAdjustQty = () => {
  //   const skuItem = skuItemList.find(e => e.locationNum === fromLocation);

  //   return skuItem ? skuItem.quantity : 1;
  // };

  const onClose = () => {
    //props.onClose();
    history.push('/smart/pack/');
  };

  const onCloseWarehouseSettingDialog = () => {
    setDefaultWarehouseVisible(false);
  };

  const onFromLocationChange = (val: any) => {
    setFromLocation(val);
    if(unpackAtSrcLocation){
      setToLocation(val);
    }
  };


  const onQtyChange = (val: any) => {
    setItemQty(val);
  };

  const onToLocationChange = (val: any) => {
    setToLocation(val);
  };

  const onUnpackSourceLocationChange = (chk: boolean) => {
    setUnpackAtSrcLocation(chk);

    if (chk) {
      setToLocation(fromLocation);
    }
  };

  const submitButtonIcon = () => {
    return isAdjusting ? <Loading3QuartersOutlined spin /> : null;
  };

  React.useEffect(() => {
    if (!inited) {
      const whNum = parseInt(
        localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY) || '-1'
      );
      const wh = getWarehouseFromCache(whNum);

      if (wh) {
        //console.log('wh', wh);
        loadInitialData(wh);
        setInited(true);
        setCurrentFromWarehouse(wh);
      } else {
        setDefaultWarehouseVisible(true);
      }
    }
  }, [currentFromWarehouse, inited, loadInitialData]);

  return (<>
    {inited && (
      <AdjustmentWrapper>
        <div className="form-item-ctn form-bottom-border">
          <div>
            <Label className="label-bold tail-colon">Warehouse</Label>
            <Label className="label-grey">{currentFromWarehouse.warehouseCode}</Label>
          </div>
        </div>
        {isLoadingWHLocation && (
          <div className="form-item-ctn">
            <Loading size={LOADING_ICON_SIZE1} />
          </div>
        )}
        {isDataInitialized() && (<>
          <div className="form-item-ctn">
            <div className="label-ctn">
              <Label className="label-bold tail-colon">Prepack SKU</Label>
            </div>
            <div className="input-ctn">
              <Input
                allowClear
                disabled={isAdjusting}
                key={`sku-input${skuInputVersion}`}
                size={FORM_ELEMENT_SIZE}
                onChange={(e)=>setPrepackSKU(e.target.value)}
              />
            </div>
          </div>
          {PrepackSKU && (<>
            <div className="form-item-ctn">
              <div className="label-ctn">
                <Label className="label-bold tail-colon">Qty</Label>
              </div>
              <div className="input-ctn input-prd-qty-ctn">
                <InputNumber
                  // addonAfter={<Label className="label-grey">Max({maxAdjustQty()})</Label>}
                  disabled={isAdjusting}
                  onChange={onQtyChange}
                  // max={maxAdjustQty()}
                  min={1}
                  size={FORM_ELEMENT_SIZE}
                  value={itemQty}
                />
              </div>
            </div>
            <div className="form-item-ctn">
              <div className="label-ctn">
                <Label className="label-bold tail-colon">From Location</Label>
              </div>
              <div className="input-ctn">
                <Select
                  disabled={isAdjusting }
                  onChange={onFromLocationChange}
                  options={toLocationOptions}
                  size={FORM_ELEMENT_SIZE}
                  style={{ width: '100%' }}
                  value={fromLocation}
                />
              </div>
            </div>
            <div className="form-item-ctn">
              <Row align="middle" className="label-ctn">
                <Label className="label-bold tail-colon">Pack at Source Location</Label>
                &nbsp;&nbsp;
                <Switch
                  disabled={isAdjusting}
                  checked={unpackAtSrcLocation}
                  checkedChildren={'Yes'}
                  onChange={onUnpackSourceLocationChange}
                  unCheckedChildren={'No'}
                />
              </Row>
            </div>
            <div className="form-item-ctn">
              <div className="label-ctn">
                <Label className="label-bold tail-colon">To Location</Label>
              </div>
              <div className="input-ctn">
                <Select
                  disabled={unpackAtSrcLocation}
                  filterOption={(value: string, option: any)=> {return option.label.toLowerCase().indexOf(value.toLowerCase()) >= 0}}
                  onChange={onToLocationChange}
                  options={toLocationOptions}
                  showSearch
                  size={FORM_ELEMENT_SIZE}
                  style={{ width: '100%' }}
                  value={toLocation}
                />
              </div>
            </div>
            <Row className="form-item-ctn bottom-btn-ctn" justify="center">
              <Button
                className="act-btn"
                disabled={!isUnpackAvailable()}
                icon={submitButtonIcon()}
                onClick={adjust}
                size={FORM_ELEMENT_SIZE}
                type="primary"
              >
                Submit
              </Button>
            </Row>
          </>)}
        </>)}
      </AdjustmentWrapper>
    )}
    {defaultWarehouseVisible && (
      <SetDefaultWarehouseDialog
        closable={false}
        close={onCloseWarehouseSettingDialog}
        visible={defaultWarehouseVisible}
      />
    )}
  </>);
};

export default UnpackAdjst;
